// local storage handler
import LocalStorageHandler from "./StateCacheStorage";

const TokenExpired = () => {
    LocalStorageHandler.set("logoutData", {"lastPage":window.location.pathname, "message": "Your session has expired. Please reauthenticate."});
};

export default TokenExpired;
